<template>
<div class="second_section mobile_div pt-2 pb-2 mt-2 mb-2">
<div class="row">
 <div class="col-lg-2">
   <p>
     <router-link :to="{name: 'invoice', params: { id: invoice.last_id }}"
         class="mb-3 btn">
       #{{ invoice.last_id }}
     </router-link>
   </p>
 </div>
  <div class="col-lg-4">
    <p>{{ invoice.title}}</p>

  </div>
  <div class="col-lg-4">
    <p v-if="invoice.order && invoice.order.status"><span class="badge badge-info">{{ invoice.order.status.title }}</span></p>
  </div>
</div>
</div>


</template>

<script>
export default {
  name: "OrderBlock",
  props: {
  invoice:Object,



  },
}
</script>

<style scoped>

</style>